export const TEST_ID = 'stateComplianceModalTankMix';
